import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { observer } from 'mobx-react';


import { Redirect } from 'react-router';
import  TimesheetTable  from "./TimesheetTable"

import _ from 'lodash';

import SelectSearchField from '../../forms/SelectSearchField';

class SelectTimesheet extends Component {
    static displayName = SelectTimesheet.name;

    constructor(props) {
        super(props);

        this.state = {
            studentTimesheets: [],
            selectedStudent: false,
            editTimesheetId: false
        };

        this.props.store.updateBanner("Timesheets");


        this.editTimesheet = this.editTimesheet.bind(this);
        this.onChangeSelection = this.onChangeSelection.bind(this);
    }


    onChangeSelection(value) {
        this.setState({ selectedStudent: value })
    }


    studentSearch() {

        let students = this.props.store.students.collection;
        students = students.filter(student => student.accountIds.length > 0);

        students.sort(this.props.store.students.sortByLastName);

        const options = students.map(student => {
            return {
                label: student.name,
                value: student.id
            }
        });


        return (
            <div className="col-12 col-md-6">
                <Formik
                    initialValues={{ accountId: "0" }}
                    onSubmit={(values, { setSubmitting }) => this.onChangeSelection(values, setSubmitting)}
                >
                    <Form>
                        <label for="studentId">Select Student</label>
                        <Field component={SelectSearchField} onChange={(value) => this.handleSubmission(value) } name="studentId" options={options} isClearable={true} />
                    </Form>
                </Formik>
            </div>
        )
    }


    handleSubmission(studentId) {
        //this.setState({ selectedStudent: values.studentId })

        let accounts = this.props.store.accounts.collection;

        accounts = accounts.map(account => account.include(["student", "timesheet"]));

        let studentAccounts = accounts.filter(account => account.student.id == studentId)


        let studentTimesheets = studentAccounts.map(account => account.timesheets);
        studentTimesheets = _.flattenDeep(studentTimesheets)
            .filter(timesheet => timesheet !== undefined && timesheet.isFinal !== false);

        //Sort timesheets reverse by submission date.
        studentTimesheets.sort((timesheetA, timesheetB) => {
            if (timesheetA.dateSubmitted > timesheetB.dateSubmitted) {
                return -1
            }
            if (timesheetB.dateSubmitted > timesheetA.dateSubmitted) {
                return 1
            }
            return 0
        });
            
        if (studentTimesheets) {
            this.setState({ "studentTimesheets": studentTimesheets })
        }

    }

    validate(values) {
        const errors = {};

        if (!values.studentId || values.studentId == "0") {
            errors.studentId = "Must select a student";
        }

        return errors;
    }

    render() {
        //If a 'edit timesheet' button was pushed.
        if (this.state.editTimesheetId) {
            return (
                <Redirect push to={"/staff/Timesheet/" + this.state.editTimesheetId} />
            )
        }
        return (
            <React.Fragment>
                <div className="row">
                    {this.studentSearch()}
                </div>
                <div className="row">
                    {this.tableDisplay()}
                </div>
            </React.Fragment>
        )
    }


    //When a user pushes the 'edit timesheet' button on timesheet table
    editTimesheet(event) {
        this.setState({ editTimesheetId: event.target.value})
    }

    tableDisplay() {
        return (
            <TimesheetTable editTimesheet={this.editTimesheet} timesheets={this.state.studentTimesheets} />
        )
    }
}

SelectTimesheet = observer(SelectTimesheet);

export { SelectTimesheet }